import PrixCategorieParRegion from '../PrixCategorieParProvince'
import { memo } from 'react'
import PrixMoyenProduitParCommune from '../PrixMoyenProduitParProvince'
import PrixProduitMarcheParCommunes from '../PrixProduitMarcheParProvince'

const ChargeurDePage = memo(() => {
    return (
        <>
{/* <PrixMoyenProduitParCommune produit="Tomates" /> */}
            <PrixProduitMarcheParCommunes produit="Tomates" />
        </>
    )
})

export default ChargeurDePage